import './component-cart-items.js';
import './component-cart-quantity-selector.js';
// Connect custom controls to Horizon's existing cart drawer and renderer.
import { sectionRenderer } from '@theme/section-renderer';
import { StandardEvents } from '@shopify/events';
const drawer = () => document.querySelector('theme-drawer#cart-drawer');
const syncHeaderWithCart = () => {
  const header = document.querySelector('#header-group');
  if (header) header.inert = !!drawer()?.hasAttribute('open');
};
if (drawer()) new MutationObserver(syncHeaderWithCart).observe(drawer(), {attributes:true, attributeFilter:['open']});
syncHeaderWithCart();
const root = window.Shopify?.routes?.root || '/';
let pending = Promise.resolve();
function updateRewards() {
  const rewards = drawer()?.querySelector('[data-rr-rewards]');
  if (!rewards) return;
  const currency = rewards.dataset.currency;
  const rate = currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
  if (!(rate > 0)) return;
  const target = Math.round(13000 * rate);
  const total = Number(rewards.dataset.total);
  const gift = rewards.querySelector('[data-rr-gift]');
  if (rewards.dataset.gift !== 'true') {
    const gap = Math.max(0, target - total);
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency}).format(gap / 100);
    gift.textContent = gap ? `Add ${money} more for a free gift` : 'Checking your free gift…';
  }
  const progress = rewards.querySelector('progress');
  if (progress) { progress.max = target; progress.value = Math.min(target,total); }
}
function updateBadge() {
  updateRewards();
  const count = Number(drawer()?.querySelector('[ref="cartItemCount"]')?.textContent || 0);
  document.querySelectorAll('.rr-top a.cart').forEach(link => {
    let badge = link.querySelector('[data-cart-count]');
    if (!badge && count) { badge = document.createElement('span'); badge.className = 'cart-badge'; badge.dataset.cartCount = ''; link.append(badge); }
    if (badge) { badge.textContent = count; badge.hidden = !count; }
    link.setAttribute('aria-label', `Cart, ${count} item${count === 1 ? '' : 's'}`);
  });
}
async function refreshDrawer() {
  await sectionRenderer.renderSection('cart-drawer-section', {cache: false, mode: 'hydration', injectStylesheet: true, url: new URL(root, location.origin)});
  updateBadge();
}
window.rrOpenCart = async () => {
  if (!drawer()) { location.href = root + 'cart'; return; }
  try {
    await pending;
    await window.rrSyncGift?.();
    await refreshDrawer();
    await customElements.whenDefined('theme-drawer');
    drawer().open();
  } catch { location.href = root + 'cart'; }
};
for (const eventName of [StandardEvents.cartLinesUpdate, StandardEvents.cartDiscountUpdate]) {
  document.addEventListener(eventName, event => {
    if (!drawer() || !event.promise) return;
    pending = pending.catch(() => {}).then(async () => {
      await event.promise;
      const result = await window.rrSyncGift?.();
      if (result?.changed) await refreshDrawer();
      updateBadge();
    });
    pending.catch(() => { location.href = root + 'cart'; });
  });
}
document.addEventListener('click', async event => {
  const add = event.target.closest('[data-rr-cart-add]');
  if (add && drawer()?.contains(add)) {
    event.preventDefault();
    if (add.disabled) return;
    add.disabled = true;
    try {
      const response = await fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items:[{id:Number(add.dataset.rrCartAdd),quantity:1}]})});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add this item. Please try again.');
      await window.rrOpenCart();
    } catch(error) {
      const status = drawer()?.querySelector('[data-rr-offer-status]');
      if (status) status.textContent = error.message;
      add.disabled = false;
    }
    return;
  }
  const link = event.target.closest('.rr-top a.cart');
  if (!link || !drawer() || event.ctrlKey || event.metaKey || event.shiftKey || event.button !== 0) return;
  event.preventDefault(); window.rrOpenCart();
});
document.addEventListener('submit', async event => {
  const form = event.target;
  if (form.matches('.best-atc') && drawer()) {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    button.disabled = true;
    try {
      const response = await fetch(form.action, {method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form)});
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'Unable to add item. Please try again.');
      await window.rrOpenCart();
    } catch (error) {
      let status = form.querySelector('[role="alert"]');
      if (!status) { status = document.createElement('p'); status.setAttribute('role','alert'); form.append(status); }
      status.textContent = error.message;
    } finally { button.disabled = false; }
  }
  if (form.closest('#cart-drawer') && event.submitter?.name === 'checkout') {
    event.preventDefault(); event.stopImmediatePropagation();
    try { await pending; await window.rrSyncGift?.(); location.href = root + 'checkout'; }
    catch { location.href = root + 'cart'; }
  }
}, true);

document.addEventListener("DOMContentLoaded", updateRewards, {once:true});
